(function () {
  'use strict';

  if (window.__vtTemplates) return;
  window.__vtTemplates = true;

  document.querySelectorAll('[data-carrousel]').forEach(function (doos) {
    var spoor = doos.querySelector('[data-car-spoor]');
    var vorige = doos.querySelector('[data-car-prev]');
    var volgende = doos.querySelector('[data-car-next]');
    if (!spoor || !vorige || !volgende) return;

    function stap() {
      var k = spoor.querySelector('.vt-ander__kaart');
      return k ? k.getBoundingClientRect().width + 8 : 120;
    }
    function knoppen() {
      var max = spoor.scrollWidth - spoor.clientWidth - 2;
      vorige.disabled = spoor.scrollLeft <= 2;
      volgende.disabled = spoor.scrollLeft >= max;
    }
    vorige.addEventListener('click', function () { spoor.scrollBy({ left: -stap() }); });
    volgende.addEventListener('click', function () { spoor.scrollBy({ left: stap() }); });
    spoor.addEventListener('scroll', knoppen);
    window.addEventListener('resize', knoppen);
    knoppen();
  });

  document.querySelectorAll('[data-hoortbij]').forEach(function (knop) {
    knop.addEventListener('click', function () {
      var ids = (knop.dataset.ids || '').split(',').filter(Boolean);
      if (ids.length < 2) return;
      var oorspronkelijk = knop.textContent;
      knop.disabled = true;
      knop.textContent = knop.dataset.bezig;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; })
        })
      })
        .then(function (r) { if (!r.ok) { throw new Error('cart/add gaf ' + r.status); } return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          knop.textContent = oorspronkelijk;
          knop.disabled = false;
        })
        .catch(function (e) {
          console.warn('[Voltrade] beide toevoegen mislukt', e);
          knop.textContent = knop.dataset.fout;
          knop.disabled = false;
        });
    });
  });
})();

